export const Types = {
    CHANGE_LANGUAGE:'CHANGE_LANGUAGE',
};